module.exports = __webpack_public_path__ + "1df2697e46e14be941922902486ce0b1.MP3";